import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { formatPrice } from '../../../../common/utils/formatters';

const Subtotal = ({ item, measure, locale }) => {
  const firstRowValue = item.subtotal !== item.price ? item.subtotal : item.price;

  const perItemRow = item.subtotal !== item.price && (
    <p className="card-price__total">
      <span>{formatPrice(item.price, locale)}</span>
      <span className="card-price__currency">{item.currency}</span>
      <span className="card-price__label">{measure}</span>
    </p>
  );

  return (
    <>
      <p className="card-price__single">
        <span>{formatPrice(firstRowValue, locale)}</span>
        <span className="card-price__currency">{item.currency}</span>
      </p>
      {perItemRow}
    </>
  );
};

Subtotal.propTypes = {
  item: propTypes.shape({
    price: propTypes.number.isRequired,
    subtotal: propTypes.number.isRequired,
    currency: propTypes.string
  }).isRequired,
  locale: propTypes.string.isRequired,
  measure: propTypes.string.isRequired
};

export default inject((allStores) => ({
  locale: allStores.optionsStore.locale
}))(observer(Subtotal));
